import React, { createContext, useContext } from "react";

interface InputFieldContextType {
	/**
	 * The id of the input
	 */
	id: string;
	/**
	 * The error message of the input
	 */
	error?: string;
	/**
	 * Whether the input is disabled
	 */
	disabled?: boolean;
	/**
	 * The info message of the input
	 */
	info?: string;
	/**
	 * Whether to disable label click behavior (htmlFor attribute)
	 */
	disableLabelClick?: boolean;
}

const InputFieldContext = createContext<InputFieldContextType | undefined>(undefined);

/**
 * Hook that returns the input field context
 */
export function useInputField() {
	const context = useContext(InputFieldContext);
	if (!context) {
		return {
			id: "",
			error: undefined,
			disabled: undefined,
			info: undefined,
			disableLabelClick: undefined,
		};
	}
	return context;
}

interface InputFieldProviderProps {
	id: string;
	error?: string;
	disabled?: boolean;
	children: React.ReactNode;
	info?: string;
	disableLabelClick?: boolean;
}

export function InputFieldProvider({
	id,
	error,
	disabled,
	children,
	info,
	disableLabelClick,
}: InputFieldProviderProps) {
	return (
		<InputFieldContext.Provider value={{ id, error, disabled, info, disableLabelClick }}>
			{children}
		</InputFieldContext.Provider>
	);
}
